import React from "react";
import {ReactSession} from "react-client-session";
import {
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogContent,
    Divider,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Select,
    Table,
    TableCell,
    Typography
} from '@mui/material'
import axios from "axios";

import {Card} from "react-bootstrap";
import {loading} from "./loading";
import TableCtrNeg from "./tabelle/Table";
import {oggi} from "../utility/returnDate"
import VariabiliGlobali from "../Back/VariabiliGlobali";
import FiltroSceltaNegozio from "./filtri/FiltroSceltaNegozio";
import FiltroSceltaData from "./filtri/FiltroSceltaData";
import FiltriArticoli, {dammiArticoli} from "./filtri/FiltriArticoli";
import statisticheLogo from "../img/venduto/statistiche.png";
import statisticheVBLogo from "../img/venduto/statistichevb.png";
import logLogo from "../img/venduto/log.png";
import invricverLogo from "../img/documenti/verificainvric.png";
import movimagaz from "../img/documenti/movimagaz.png";
import NessunRisultato from "./NessunRisultato";
import FiltriTotali from "./filtri/FiltriTotali";
import theme from "../theme";
import {BottoneFinePagina} from "./bottoni/BottoneFinePagina";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {BottoneInizioPagina} from "./bottoni/BottoneInizioPagina";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";


export class Documenti extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInizio: oggi(),
            dataFine: oggi(),
            loading: false,
            doveMiTrovo: 'documenti',
            sceltanegozio: 'Tutti',
            statDocTab: [],
            statInvRic: [],
            statMovimenti: [],
            log: [],
            imponibili: false,
            descrizione: "",
            marca: "",
            reparto: "",
            ricercaEffettuata: false,
            filtrototale: "XXX",
            promo: "0",
            idpromo: "",
            ARTICOLI: [],
            testoDialog: '',
            filtroTipo: '0',
        };
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cambiaNegozio = this.cambiaNegozio.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleChangeDataInizio = this.handleChangeDataInizio.bind(this);
        this.handleChangeDataFine = this.handleChangeDataFine.bind(this);
        this.handleChangeArticolo = this.handleChangeArticolo.bind(this);
        this.handleChangeTotali = this.handleChangeTotali.bind(this);
    }

    cambiaNegozio(variabile) {
        this.setState({sceltanegozio: variabile})
    }

    handleChangeDataInizio(variabile) {
        this.setState({dataInizio: variabile})
    }

    handleChangeDataFine(variabile) {
        this.setState({dataFine: variabile})
    }

    handleChangeArticolo(descrizione, marca, reparto, promo, idpromo) {
        this.setState({descrizione: descrizione})
        this.setState({marca: marca})
        this.setState({reparto: reparto})
        this.setState({promo: promo})
        this.setState({idpromo: idpromo})
    }

    handleChangeDataInizio(variabile) {
        this.setState({dataInizio: variabile})
    }

    handleChangeDataFine(variabile) {
        this.setState({dataFine: variabile})
    }

    handleChange(event, provenienza) {
        if (provenienza === 'ctrDoc') {
            this.setState({doveMiTrovo: 'ctrDoc'})
        }
        if (provenienza === 'ctrStat') {
            this.setState({doveMiTrovo: 'ctrStat'})
        }
        if (provenienza === 'ctrStatVB') {
            this.setState({doveMiTrovo: 'ctrStatVB'})
        }
        if (provenienza === 'log') {
            this.setState({doveMiTrovo: 'log'})
        }
        if (provenienza === 'movimagaz') {
            this.setState({doveMiTrovo: 'movimagaz'})
        }
        if (provenienza === 'imponibili') {
            if (this.state.imponibili === true) {
                this.setState({imponibili: false});
            } else {
                this.setState({imponibili: true});
            }
        }
        if (provenienza === 'tipo') {
            let tipo = event.target.value;
            this.setState({filtroTipo: tipo});
        }
    }

    handleChangeTotali(variabile, variabile2) {
        let varia = "XXX";
        if (variabile.toString().startsWith("Scelta")) {
            varia = "XXX";
        } else {
            if (variabile2.toString().trim().length > 0) {
                if (!(isNaN(variabile2))) {
                    varia = variabile + '' + variabile2;
                }
            }
        }
        this.setState({filtrototale: varia})
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.doveMiTrovo === 'ctrDoc') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            const params = new URLSearchParams();
            let sceltanegozio = this.state.sceltanegozio
            params.append('dataInizio', dataini);
            params.append('dataFine', datafine);
            params.append('negozio', sceltanegozio);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/ControlloDocumento';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({statInvRic: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })

        }
        if (this.state.doveMiTrovo === 'movimagaz') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let filtroTipo = this.state.filtroTipo
            const params = new URLSearchParams();
            let sceltanegozio = this.state.sceltanegozio
            params.append('dataInizio', dataini);
            params.append('dataFine', datafine);
            params.append('negozio', sceltanegozio);
            params.append('filtroTipo', filtroTipo);

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/ControlloMovimenti';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({statMovimenti: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })

        }
        if (this.state.doveMiTrovo === 'ctrStat') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let sceltanegozio = this.state.sceltanegozio
            let imponibili = this.state.imponibili
            let articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.idpromo)

            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('negozio', sceltanegozio);
            params.append('dataFine', datafine);
            params.append('imponibili', imponibili);
            params.append('articoli', articoli);
            params.append('filtrototale', this.state.filtrototale);

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/TabellaStatisticheDoc';
            axios.post(url, params, config)
                .then((response) => {

                    this.setState({statDocTab: ''});
                    this.setState({statDocTab: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }

        if (this.state.doveMiTrovo === 'ctrStatVB') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            let sceltanegozio = this.state.sceltanegozio
            let imponibili = this.state.imponibili
            let articoli = await dammiArticoli(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.state.idpromo)

            const params = new URLSearchParams();
            params.append('idmagazzino', this.idmagazzino);
            params.append('dataInizio', dataini);
            params.append('negozio', sceltanegozio);
            params.append('dataFine', datafine);
            params.append('imponibili', imponibili);
            params.append('articoli', articoli);
            params.append('filtrototale', this.state.filtrototale);

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/TabellaStatisticheVB';
            axios.post(url, params, config)
                .then((response) => {

                    this.setState({statDocTab: ''});
                    this.setState({statDocTab: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }

        if (this.state.doveMiTrovo === 'log') {
            event.preventDefault();
            this.setState({loading: true})
            let dataini = this.state.dataInizio
            let datafine = this.state.dataFine
            const params = new URLSearchParams();
            let sceltanegozio = this.state.sceltanegozio
            params.append('dataInizio', dataini);
            params.append('dataFine', datafine);
            params.append('negozio', sceltanegozio);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/Log';
            axios.post(url, params, config)
                .then((response) => {
                    this.setState({log: response.data});
                    this.setState({loading: false})
                })
                .catch((error) => {
                    console.log('Errore: ' + error);
                    alert(error);
                })

        }

        this.setState({ricercaEffettuata: true})
    }


    landing() {
        return (
            <div>
                <Grid className="center" container direction="column" spacing={3}>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="invricver"
                                     onClick={(e) => this.handleChange(e, "ctrDoc")}
                                     src={invricverLogo}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="movimagaz"
                                     onClick={(e) => this.handleChange(e, "movimagaz")}
                                     src={movimagaz}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="statistiche"
                                     onClick={(e) => this.handleChange(e, "ctrStat")}
                                     src={statisticheLogo}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="statistiche"
                                     onClick={(e) => this.handleChange(e, "ctrStatVB")}
                                     src={statisticheVBLogo}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined" sx={{minWidth: 275}}>
                            <CardContent style={{backgroundColor: '#ECECFB'}} className="elemento">
                                <img id="log"
                                     onClick={(e) => this.handleChange(e, "log")}
                                     src={logLogo}
                                     alt=" "
                                     className="d-inline-block align-top"/> </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }

    ctrDoc() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={false}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <FiltroSceltaData
                        dataInizio={this.state.dataInizio}
                        dataFine={this.state.dataFine}
                        sceltaIntervallo={true}
                        handleChangeDataInizio={this.handleChangeDataInizio}
                        handleChangeDataFine={this.handleChangeDataFine}
                    />
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div>
                            {this.state.statInvRic.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.statInvRic}/>
                                </div>
                            )}
                            {this.state.statInvRic.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    moviMagaz() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={false}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <FiltroSceltaData
                        dataInizio={this.state.dataInizio}
                        dataFine={this.state.dataFine}
                        sceltaIntervallo={true}
                        handleChangeDataInizio={this.handleChangeDataInizio}
                        handleChangeDataFine={this.handleChangeDataFine}
                    />
                </Grid>
                <Grid item>
                    <Select
                        labelId="demo-simple-select-label"
                        id="selectVisua"
                        value={this.state.filtroTipo}
                        label=''
                        onChange={(e) => this.handleChange(e, "tipo")}
                    >
                        <MenuItem value={"0"}>Nessun filtro</MenuItem>
                        <MenuItem value={"1"}>DANNEGGIAMENTO</MenuItem>
                        <MenuItem value={"2"}>FURTO</MenuItem>
                        <MenuItem value={"3"}>CONSUMI INTERNI</MenuItem>
                        <MenuItem value={"4"}>RETTIFICA CARICO</MenuItem>
                        <MenuItem value={"5"}>RETTIFICA SCARICO</MenuItem>
                        <MenuItem value={"6"}>PASSAGGI MAGAZZINO</MenuItem>
                    </Select>
                    <FormHelperText>Tipo movimento</FormHelperText>
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div>
                            {this.state.statMovimenti.length > 0 && (
                                <div>
                                    <Divider/>
                                    {this.tabellaMovimenti()}
                                </div>
                            )}
                            {this.state.statMovimenti.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    handleClickOpen(ARTICOLI, testoDialog) {
        this.setState({ARTICOLI: ARTICOLI})
        this.setState({testoDialog: testoDialog})
        this.setState({open: true})
    };

    handleClose() {
        this.setState({ARTICOLI: []})
        this.setState({testoDialog: ""})
        this.setState({open: false});
    };

    dialog() {
        return (
            <Dialog fullScreen open={this.state.open}
                    aria-labelledby="form-dialog-title">
                <DialogContent>
                    <Grid container direction={"column"} spacing={1}>
                        <Grid item>
                            <Grid container direction={"row"} spacing={1}>
                                <Grid item>
                                    <Button variant="contained"
                                            onClick={(e) => this.handleClose()}>
                                        Chiudi
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Typography><b>{this.state.testoDialog}</b></Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>

                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><b>Rigo</b></TableCell>
                                            <TableCell><b>ID</b></TableCell>
                                            <TableCell><b>Descrizione</b></TableCell>
                                            <TableCell><b>Quantità</b></TableCell>
                                            <TableCell><b>Prezzo Imponibile</b></TableCell>
                                            <TableCell><b>Prezzo Ivato</b></TableCell>
                                            <TableCell><b>Sconto</b></TableCell>
                                            <TableCell><b>Prezzo finito</b></TableCell>
                                            <TableCell><b>Importo</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.ARTICOLI.map((articoliRow, index) => (
                                            <TableRow key={index}>
                                                <TableCell><b>{articoliRow.riga}</b></TableCell>
                                                <TableCell><b>{articoliRow.id}</b></TableCell>
                                                <TableCell><b>{articoliRow.descrizione}</b></TableCell>
                                                <TableCell><b>{articoliRow.qta}</b></TableCell>
                                                <TableCell><b>{Number(articoliRow.preIMP).toFixed(2)}</b></TableCell>
                                                <TableCell><b>{Number(articoliRow.preIVA).toFixed(2)}</b></TableCell>
                                                <TableCell><b>{articoliRow.sc1}</b></TableCell>
                                                <TableCell><b>{Number(articoliRow.preFIN).toFixed(2)}</b></TableCell>
                                                <TableCell><b>{Number(articoliRow.importo).toFixed(2)}</b></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        )
    }

    tabellaMovimenti() {
        return (<Grid container direction={"column"} spacing={2}>
            <Grid item>
                <BottoneFinePagina/>
            </Grid>
            <Grid item>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>ID</b></TableCell>
                                <TableCell><b>DATA E ORA</b></TableCell>
                                <TableCell><b>TIPO</b></TableCell>
                                <TableCell><b>NOTE</b></TableCell>
                                <TableCell><b>TOTALE</b></TableCell>
                                <TableCell> </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.statMovimenti.map((mov, index) => (
                                <TableRow key={index}>
                                    <TableCell>{mov.ID}</TableCell>
                                    <TableCell>{mov.DATAORAFO}</TableCell>
                                    <TableCell>{mov.TIPO}</TableCell>
                                    <TableCell>{mov.NOTE}</TableCell>
                                    <TableCell>{mov.TOTALE}</TableCell>
                                    <TableCell>
                                        <Button variant="contained"
                                                onClick={e => this.handleClickOpen(mov.tabella, "Movimento " + mov.ID + " del " + mov.DATAORAFO)}>
                                            Dettaglio movimento
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <Grid container direction="row" spacing={3}>
                    <Grid item>
                        <BottoneInizioPagina/>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
            </Grid>
        </Grid>)
    }

    ctrStat() {
        return (
            <div>
                <div>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Card className="center" sx={{minWidth: 275}} spacing={3}>
                                <FiltroSceltaNegozio
                                    visualizzaMaga={true}
                                    sceltaneg={"Tutti"}
                                    visualizzaTutti={true}
                                    cambiaNegozio={this.cambiaNegozio}
                                />
                            </Card>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <FiltroSceltaData
                                        dataInizio={this.state.dataInizio}
                                        dataFine={this.state.dataFine}
                                        sceltaIntervallo={true}
                                        handleChangeDataInizio={this.handleChangeDataInizio}
                                        handleChangeDataFine={this.handleChangeDataFine}
                                    />
                                </Grid>
                                <Grid item>
                                    <FiltriTotali
                                        handleChangeTotali={this.handleChangeTotali}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <FiltriArticoli
                                descrizione=""
                                marca=""
                                reparto="0"
                                promo="0"
                                handleChangeArticolo={this.handleChangeArticolo}
                            />
                        </Grid>
                        <Grid item>
                            <FormLabel component="legend">
                                <Checkbox
                                    value={this.state.imponibili}
                                    onChange={(e) => this.handleChange(e, "imponibili")}
                                />Prezzi imponibili
                            </FormLabel>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                    onClick={this.handleSubmit}>Avvia
                                ricerca</Button>
                        </Grid>
                    </Grid>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div className='elemento'>
                            {this.state.statDocTab.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.statDocTab}/>
                                </div>
                            )}
                            {this.state.statDocTab.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    ctrStatVB() {
        return (
            <div>
                <div>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Card className="center" sx={{minWidth: 275}} spacing={3}>
                                <FiltroSceltaNegozio
                                    visualizzaMaga={true}
                                    sceltaneg={"Tutti"}
                                    visualizzaTutti={true}
                                    cambiaNegozio={this.cambiaNegozio}
                                />
                            </Card>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <FiltroSceltaData
                                        dataInizio={this.state.dataInizio}
                                        dataFine={this.state.dataFine}
                                        sceltaIntervallo={true}
                                        handleChangeDataInizio={this.handleChangeDataInizio}
                                        handleChangeDataFine={this.handleChangeDataFine}
                                    />
                                </Grid>
                                <Grid item>
                                    <FiltriTotali
                                        handleChangeTotali={this.handleChangeTotali}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <FiltriArticoli
                                descrizione=""
                                marca=""
                                reparto="0"
                                promo="0"
                                handleChangeArticolo={this.handleChangeArticolo}
                            />
                        </Grid>
                        <Grid item>
                            <FormLabel component="legend">
                                <Checkbox
                                    value={this.state.imponibili}
                                    onChange={(e) => this.handleChange(e, "imponibili")}
                                />Prezzi imponibili
                            </FormLabel>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                    onClick={this.handleSubmit}>Avvia
                                ricerca</Button>
                        </Grid>
                    </Grid>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div className='elemento'>
                            {this.state.statDocTab.length > 0 && (
                                <div>
                                    <Divider/>
                                    <TableCtrNeg data={this.state.statDocTab}/>
                                </div>
                            )}
                            {this.state.statDocTab.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.state.doveMiTrovo === 'documenti' && (
                    <div>
                        {this.landing()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'ctrDoc' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>VERIFICA INVIO/RICEVI </Typography>
                        </Card>
                        <br/>

                        {this.ctrDoc()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'ctrStat' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>STATISTICHE DOCUMENTI </Typography>
                        </Card>
                        <br/>
                        {this.ctrStat()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'ctrStatVB' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>STATISTICHE VENDITE AL BANCO </Typography>
                        </Card>
                        <br/>
                        {this.ctrStatVB()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'movimagaz' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>MOVIMENTO DI MAGAZZINO</Typography>
                        </Card>
                        <br/>
                        {this.dialog()}
                        {this.moviMagaz()}
                    </div>
                )}
                {this.state.doveMiTrovo === 'log' && (
                    <div>
                        <Card style={{backgroundColor: '#ECECFB'}} className="center" sx={{minWidth: 275}}>
                            <Typography>LOG</Typography>
                        </Card>
                        <br/>
                        {this.log()}
                    </div>
                )}
            </div>
            //<form action="" method="post">

        )
    }


    log() {
        return (
            <Grid container direction="column" spacing={3}>
                <Grid item>
                    <Card className="center" sx={{minWidth: 275}} spacing={3}>
                        <FiltroSceltaNegozio
                            visualizzaMaga={true}
                            sceltaneg={this.idmagazzino}
                            visualizzaTutti={false}
                            cambiaNegozio={this.cambiaNegozio}
                        />
                    </Card>
                </Grid>
                <Grid item>
                    <FiltroSceltaData
                        dataInizio={this.state.dataInizio}
                        dataFine={this.state.dataFine}
                        sceltaIntervallo={true}
                        handleChangeDataInizio={this.handleChangeDataInizio}
                        handleChangeDataFine={this.handleChangeDataFine}
                    />
                </Grid>
                <Grid item>
                    <Grid item>
                        <Button variant="contained" style={theme.palette.verde} name='SubmitButton'
                                onClick={this.handleSubmit}>Avvia
                            ricerca</Button>
                    </Grid>
                </Grid>
                <Grid item>
                    {this.state.loading === true ? (
                        <div>
                            {loading()}
                        </div>
                    ) : (
                        <div>
                            {this.state.log.length > 0 && (
                                <div>
                                    <Divider/>
                                    {this.tabellaLog()}
                                </div>
                            )}
                            {this.state.log.length === 0 && this.state.ricercaEffettuata && (
                                <NessunRisultato/>
                            )}
                        </div>
                    )}
                </Grid>
            </Grid>
        )
    }

    tabellaLog() {
        return (<Grid container direction={"column"} spacing={2}>
            <Grid item>
                <BottoneFinePagina/>
            </Grid>
            <Grid item>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>UTENTE</b></TableCell>
                                <TableCell><b>OPERAZIONE</b></TableCell>
                                <TableCell><b>DATA</b></TableCell>
                                <TableCell><b>ORA</b></TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.log.map((mov, index) => (
                                <TableRow key={index}>
                                    <TableCell>{mov.utente}</TableCell>
                                    <TableCell>{mov.operazione}</TableCell>
                                    <TableCell>{mov.dataFO}</TableCell>
                                    <TableCell>{mov.ora}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <Grid container direction="row" spacing={3}>
                    <Grid item>
                        <BottoneInizioPagina/>
                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
            </Grid>
        </Grid>)
    }

}
